import { createContext } from "react";
import { IPermissionContext } from "./types";

const initialState: IPermissionContext = {
  hasPermission: () => false,
};
const PermissionContext = createContext<IPermissionContext>(initialState);

export default PermissionContext;
